var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _line, _line2, _rect6, _rect7, _rect8, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line3, _line4, _rect9, _rect10, _rect11, _path11, _rect12, _rect13, _rect14, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 25.2124,
    transform: "matrix(0.00364554 -0.999993 0.999957 0.00932149 246.912 129.522)",
    fill: "url(#paint0_linear_422_3093)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 50.1352,
    transform: "matrix(1 9.1403e-10 -0.00567604 0.999984 317.509 67.4233)",
    fill: "url(#paint1_linear_422_3093)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 57.1599,
    transform: "matrix(0.00452379 -0.999995 -0.999825 -0.0164247 394.984 352.536)",
    fill: "url(#paint2_linear_422_3093)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 57.155,
    transform: "matrix(0.00444625 -0.999995 1 -0.00335237 239.812 351.925)",
    fill: "url(#paint3_linear_422_3093)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 25.0451,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 389.606 128.166)",
    fill: "url(#paint4_linear_422_3093)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212 307.842L218 322.842C218.666 324.342 220.4 327.342 222 327.342C223.6 327.342 229.333 327.342 232 327.342",
    stroke: "url(#paint5_linear_422_3093)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423 307.842L417 322.842C416.333 324.342 414.6 327.342 413 327.342C411.4 327.342 405.666 327.342 403 327.342",
    stroke: "url(#paint6_linear_422_3093)",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 212,
    y1: 308.342,
    x2: 224,
    y2: 308.342,
    stroke: "url(#paint7_linear_422_3093)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 12,
    y2: -0.5,
    transform: "matrix(-1 0 3.45635e-10 1 423 308.842)",
    stroke: "url(#paint8_linear_422_3093)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 256.842,
    width: 1,
    height: 1,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 256.842,
    width: 1,
    height: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 256.842,
    width: 1,
    height: 1,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340.386 217.985L340.874 132.04C340.801 130.847 341.567 128.638 345.219 129.354L516.955 129.354C518.721 128.981 522.919 129.534 525.583 134.726L569.497 195.156C570.849 197.021 574.372 200.751 577.643 200.751L634.648 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.16 218.209L295.649 132.183C295.736 130.988 294.994 128.777 291.331 129.494L119.458 129.494C117.695 129.121 113.487 129.674 110.762 134.872L66.1264 195.373C64.7517 197.24 61.1838 200.975 57.91 200.975L0.859794 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.606 316.911L294.565 324.073C294.64 325.117 294.163 327.206 291.661 327.206L221.668 327.206C221.027 327.206 219.27 325.953 217.374 320.94C216.958 319.838 215 315.017 212.021 307.735M0.741922 221.79L20.8258 221.79M138.144 189.784L138.123 193.365L138.165 185.979M138.144 189.784L149.509 189.784M138.144 189.784L126.779 189.784M149.509 189.784L160.873 189.784C162.99 189.784 164.468 192.172 164.942 193.365C175.146 218.091 191.767 258.404 203.575 287.144M149.509 189.784L149.488 193.365L149.53 185.979M126.779 189.784L115.414 189.784C113.972 189.635 110.409 190.142 107.697 193.365L97.1634 205.787M126.779 189.784L126.759 193.365L126.8 185.979M97.1634 205.787L86.63 218.209C85.4206 219.402 82.617 221.79 81.0776 221.79L60.9937 221.79M97.1634 205.787L107.626 205.787L86.7005 205.787M40.9098 221.79L40.8831 226.49M40.9098 221.79L60.9937 221.79M40.9098 221.79L20.8258 221.79M60.9937 221.79L60.967 226.49M20.8258 221.79L20.7992 226.49M212.021 307.735L223.703 307.735M212.021 307.735C210.779 304.7 209.361 301.238 207.802 297.439M207.802 297.439L223.761 297.439M207.802 297.439C206.485 294.229 205.069 290.779 203.575 287.144M203.575 287.144L223.82 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M339.833 316.911L339.792 324.073C339.706 325.117 340.159 327.206 342.661 327.206L412.654 327.206C413.295 327.206 415.066 325.953 417.019 320.94C417.448 319.838 419.461 315.017 422.522 307.735M634.777 221.79L614.693 221.79M497.738 189.784L497.718 193.365L497.76 185.979M497.738 189.784L486.374 189.784M497.738 189.784L509.103 189.784M486.374 189.784L475.009 189.784C472.892 189.784 471.387 192.172 470.899 193.365C460.415 218.091 443.336 258.404 431.202 287.144M486.374 189.784L486.353 193.365L486.395 185.979M509.103 189.784L520.468 189.784C521.912 189.635 525.469 190.142 528.145 193.365L538.537 205.787M509.103 189.784L509.083 193.365L509.125 185.979M538.537 205.787L548.929 218.209C550.125 219.402 552.902 221.79 554.441 221.79L574.525 221.79M538.537 205.787L528.074 205.787L549 205.787M594.609 221.79L594.582 226.49M594.609 221.79L574.525 221.79M594.609 221.79L614.693 221.79M574.525 221.79L574.498 226.49M614.693 221.79L614.666 226.49M422.522 307.735L410.84 307.735M422.522 307.735C423.798 304.7 425.256 301.238 426.858 297.439M426.858 297.439L410.899 297.439M426.858 297.439C428.211 294.229 429.667 290.779 431.202 287.144M431.202 287.144L410.957 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.35 201.87L319.356 24.6092C319.36 23.8631 319.849 22.371 321.774 22.371L524.056 22.371C526.301 22.4456 530.794 21.8339 530.811 18.79C530.828 15.7461 530.874 7.6739 530.895 4.01826C530.82 3.12301 531.247 1.33249 533.556 1.33249L625.507 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.842 201.87L318.848 24.6092C318.853 23.8631 318.381 22.371 316.459 22.371L114.484 22.371C112.242 22.4456 115.854 21.6537 115.872 18.6099C115.889 15.566 115.935 7.49375 115.956 3.83812C116.041 2.94286 107.543 1.33249 105.237 1.33249L11.0206 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.598 337.726L317.553 345.783C317.381 347.723 318.097 351.602 322.33 351.602L497.193 351.602C498.475 351.751 501.959 350.886 505.642 346.231L563.296 274.162C564.345 272.894 566.877 270.357 568.609 270.357L634.273 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M316.597 337.726L316.551 345.783C316.7 347.723 315.941 351.602 311.707 351.602L136.845 351.602C135.561 351.751 132.087 350.886 128.457 346.231L71.6209 274.162C70.5858 272.894 68.0827 270.357 66.3509 270.357L0.687303 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.765 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.35352 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.018 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.093 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.169 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M575.24 193.664C575.243 193.252 575.579 192.918 575.991 192.918L584.317 192.918C585.422 192.918 586.312 193.813 586.306 194.918L586.302 195.549C586.297 196.568 585.466 197.394 584.447 197.394L578.95 197.394C576.889 197.394 575.229 195.724 575.24 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.311 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.2354 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1597 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0797 193.664C61.0821 193.252 60.75 192.918 60.3379 192.918L52.0112 192.918C50.9067 192.918 50.0062 193.813 49.9999 194.918L49.9963 195.549C49.9905 196.568 50.8121 197.394 51.8313 197.394L57.3283 197.394C59.3885 197.394 61.0681 195.724 61.0797 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_3093",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 25.2124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_422_3093",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_422_3093",
    x1: 0.909125,
    y1: 0,
    x2: 0.909125,
    y2: 57.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_422_3093",
    x1: 0.909125,
    y1: 0,
    x2: 0.909125,
    y2: 57.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_422_3093",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 25.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_422_3093",
    x1: 212,
    y1: 307.842,
    x2: 225.602,
    y2: 328.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_422_3093",
    x1: 423,
    y1: 307.842,
    x2: 409.397,
    y2: 328.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_422_3093",
    x1: 212,
    y1: 309.342,
    x2: 224,
    y2: 309.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_422_3093",
    x1: 0,
    y1: 0.5,
    x2: 12,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame6);
export default __webpack_public_path__ + "static/media/card1-frame6.af52ab02fc0c7c87cab82b897446575f.svg";
export { ForwardRef as ReactComponent };